import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';

import styles from './Header.module.scss';
import { logout, selectIsAuth } from '../../redux/slices/auth';
import statImg from '../../img/logo.png';

export const Header = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const isAuth = useSelector(selectIsAuth);

  const onClickLogout = () => {
    if (window.confirm(t('logout.confirm'))) {
      dispatch(logout());
      window.localStorage.removeItem('token');
    }
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className={styles.root}>
      <Container maxWidth="lg">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Link to="/">
              <img className={styles.logo} src={statImg} alt=""/>
            </Link>
            <h2 className={styles.title}>
              {t('header.title')}<br/>
              {t('header.subtitle')}
            </h2>
          </div>
          <div>
            <Button 
              onClick={() => changeLanguage('en')} 
              variant="outlined" 
              color="primary"
              sx={{
                fontSize: { xs: '12px', sm: '14px' }, 
                padding: { xs: '4px 0', sm: '6px 16px' }, 
                minWidth: { xs: '31px', sm: '64px' }, 
              }}
            >
              Eng
            </Button>
            <Button 
              onClick={() => changeLanguage('kk')} 
              variant="outlined" 
              color="primary"
              sx={{
                fontSize: { xs: '12px', sm: '14px' }, 
                padding: { xs: '4px 0', sm: '6px 16px' }, 
                minWidth: { xs: '31px', sm: '64px' }, 
                marginLeft: {xs: "5px", sm: '10px' },
              }}
            >
              Қаз
            </Button>
            <Button 
              onClick={() => changeLanguage('ru')} 
              variant="outlined" 
              color="primary"
              sx={{
                fontSize: { xs: '12px', sm: '14px' }, 
                padding: { xs: '4px 0', sm: '6px 16px' }, 
                minWidth: { xs: '31px', sm: '64px' }, 
                marginLeft: {xs: "5px", sm: '10px' },
              }}
            >
              Рус
            </Button>
            {isAuth && (
              <Button variant="contained" color="secondary" onClick={onClickLogout}>
                {t('logout.button')}
              </Button>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};